import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {Breadcrumb, Button, Col, Form, Input, message, Row, Select, Space, Table, Tag} from "antd";
import {
    FileSearchOutlined,
    FileTextOutlined,
    UploadOutlined
} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./List.module.css";
import SupplierSelect from "../supplier/SupplierSelect";

const SupplierGoodsList = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [data,setData] = useState({pageIndex:1,pageSize:store.main.pageSize,total:0,list:[]});

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/supplier/goods/list"});

            handleSearchGoods();
        }
        //eslint-disable-next-line
    }, [store.main.userName]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadGoods(data.pageIndex, data.pageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleLoadGoods = (goodsPageIndex, goodsPageSize) => {
        if (request.current) {
            return;
        }
        let data = form.getFieldsValue();
        data.pageNum = goodsPageIndex;
        data.pageSize = goodsPageSize;

        if (!data.supplier){
            return;
        }

        request.current = true;
        setIsLoad(true);
        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/supplier/business/website/v1/goods/list",
            data: data,
            success: (response) => {
                setData(response.data)
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                    response.data.total == "undefined" ||
                    response.data.total == null ||
                    response.data.list == "undefined" ||
                    response.data.list == null
                );
            },
        });
    };

    const handleAddGoods = (supplier,supplierHotelId,supplierSpuId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: `/supplier/goods/add/${supplier}/${supplierHotelId}/${supplierSpuId}`,
        });
    };

    const handleEditGoods = (goodsId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url:`/goods/edit/${goodsId}`,
        });
    };

    const handleSearchGoods = () => {
        handleLoadGoods(1, data.pageSize);
    };

    const handleChangeGoodsPagination = (goodsPageIndex, goodsPageSize) => {
        handleLoadGoods(goodsPageIndex, goodsPageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>

                        <Button loading={isLoad} icon={<FileSearchOutlined/>} type="primary" size="large"
                                onClick={handleSearchGoods}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError}
                                 isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="供货渠道"
                                labelAlign={"left"}
                                name="supplier"
                                initialValue={"WDM"}
                                rules={[
                                    {
                                        required: false,
                                        message: "请选择供货渠道",
                                    },
                                ]}
                            >
                                <SupplierSelect className={Style.card_field} hideName="WO_DE"  onChange={handleSearchGoods}></SupplierSelect>
                            </Form.Item>
                        </Col>
                        { data.qryType? <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="商品类型"
                                labelAlign={"left"}
                                name="type"
                                initialValue={null}
                                rules={[
                                    {
                                        required: false,
                                        message: "",
                                    },
                                ]}
                            >
                                <Select className={Style.card_field} placeholder="请选择商品类型"  allowClear>
                                    {data.typeList ? data.typeList.map((item)=>{return (<Select.Option  key={item.value}  value={item.value}>{item.label}</Select.Option>)}):''}
                                </Select>
                            </Form.Item>
                        </Col> :''  }
                        {data.qrySpuName?<Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="商品名称"
                                labelAlign={"left"}
                                name="spuName"
                                initialValue={null}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入商品名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入商品名称" allowClear
                                       onPressEnter={handleSearchGoods}/>
                            </Form.Item>
                        </Col>:''}
                        {data.qryHotelName?<Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="酒店名称"
                                labelAlign={"left"}
                                name="hotelName"
                                initialValue={null}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入酒店名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入酒店名称" allowClear
                                       onPressEnter={handleSearchGoods}/>
                            </Form.Item>
                        </Col>:''}
                        {data.qryCity?<Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="城市名称"
                                labelAlign={"left"}
                                name="city"
                                initialValue={null}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入城市名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入城市名称" allowClear
                                       onPressEnter={handleSearchGoods}/>
                            </Form.Item>
                        </Col>:''}
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.spuId}
                        columns={[
                            {
                                title: "供货渠道",
                                width: 40,
                                render:()=>data.supplierLabel
                            },
                            {
                                title: "省份/城市",
                                width: 60,
                                render: (text, record, recordIndex) => {
                                    return record.prov + "/" + record.city
                                }
                            },
                            {
                                title: "酒店名称/酒店编号",
                                width: 120,
                                render: (text, record, recordIndex) =>(
                                    <React.Fragment>
                                        <div>{record.hotelName}</div>
                                        <div className={Style.hotel_id}>ID:{record.hotelId}</div>
                                    </React.Fragment>
                                )
                            },
                            ...data.qryType?[{
                                    title: "商品类型",
                                    width: 60,
                                    dataIndex: "typeLabel",
                                }]:[],
                            {
                                title: "商品名称",
                                width: 180,
                                dataIndex: "spuName",
                                render: (text, record, recordIndex) =>(
                                    <React.Fragment>
                                        <div>{record.spuName}</div>
                                        <div className={Style.hotel_id}>ID:{record.spuId}</div>
                                    </React.Fragment>
                                )
                            },
                            {
                                title: "销售时间",
                                width: 90,
                                render: (text, record, recordIndex) => (
                                    <React.Fragment>
                                        <div>{record.sellDateStart } ~ </div>
                                        <div>{record.sellDateStop}</div>
                                    </React.Fragment>
                                )
                            },
                            ...data.qryExpiry?[{title:"商品有效期",width: 100,render:(text,record,recordIndex)=>(
                                    <div>
                                        <div>
                                            { record.ebTime && record.epTime? record.ebTime + " ~ "+record.epTime:''   }
                                            { record.ebTime && !record.epTime? '开始 '+record.ebTime:''   }
                                            { !record.ebTime && record.epTime? '截止 '+record.epTime:''   }
                                        </div>
                                        {record.expDays?<div>领取后{record.expDays}天可用</div>:''}
                                    </div>
                                )}]:[],
                            {
                                title: "入库状态",
                                width: 110,
                                dataIndex: "spuStatus",
                                render: (value) => {
                                    switch (value) {
                                        case "IMPORT":
                                            return <Tag color="blue">已入库</Tag>;
                                        case "NOT_IMPORT":
                                            return <Tag color="yellow">未入库</Tag>;
                                        case "HAVE_UPDATE":
                                            return <Tag color="red">有更新</Tag>;
                                        default:
                                            return "";
                                    }
                                },
                            },
                            {
                                title: "操作",
                                fixed: "right",
                                width: 100,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        {record.spuStatus === "NOT_IMPORT" ? (
                                            <Button icon={<UploadOutlined/>} size="default"
                                                    onClick={() => handleAddGoods(data.supplier,record.hotelId,record.spuId)}>
                                                入库
                                            </Button>) : null
                                        }
                                        {record.spuStatus === "HAVE_UPDATE" ? (
                                            <Button icon={<FileTextOutlined/>} size="default"
                                                    onClick={() => handleEditGoods(record.goodsId)}>
                                                更新
                                            </Button>) : null
                                        }
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={data.list}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 220} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: data.pageIndex,
                            pageSize: data.pageSize,
                            total: data.total,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeGoodsPagination,
                            onShowSizeChange: handleChangeGoodsPagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            {/*<div style={{fontSize:"12px",color:"#6e6d6d",marginBottom:"20px"}}>*提示：商品选品信息由供货渠道提供，可通过入库操作进行商品入库。</div>*/}
            <div className={Style.footer}></div>
        </div>
    );
};

SupplierGoodsList.propTypes = {};

SupplierGoodsList.defaultProps = {};

export default SupplierGoodsList;
